// src/components/legal/LegalPage.jsx
import './LegalPage.css';

export default function LegalPage({ title, children }) {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>{title}</h1>
        <div className="legal-content">{children}</div>
      </div>
    </div>
  );
}
